import React, { useContext, useEffect } from "react";
import { Login, SignUp } from "../components";
import { CreateComment } from "../components/CreateComment";
import { UserContext } from "./UserProvider";

export const Drawer = ({ height, inputProps, parent }) => {
  const user = useContext(UserContext);

  useEffect(() => {
    if (parent.current) {
      const padding = 95;
      parent.current.style.paddingBottom = `${height + padding}px`;
    }
  }, [height]);

  const renderPage = () => {
    if (user?.username) {
      return <CreateComment {...inputProps} />;
    }
    if (!user) {
      return <Login />;
    }
  };

  return (
    <footer
      id="footerDiv"
      className="rounded-lg p-4 text-center text-white px-2 absolute bottom-0 mx-auto w-full"
    >
      {renderPage()}
    </footer>
  );
};
